import { MaterialCssVariablesConfig } from "angular-material-css-vars";
export const config:Partial<MaterialCssVariablesConfig> = {
  isAutoContrast: true,
  darkThemeClass: 'isDarkTheme',
  lightThemeClass: 'isLightTheme'
};
